var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ViewContainerRef, OnInit, OnDestroy } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, RouteConfigLoadStart, RouteConfigLoadEnd, NavigationEnd } from '@angular/router';
import { BlockUI } from 'ng-block-ui';
import { LoginService } from './shared/services/login.service';
import { AlertService } from './shared/services/alert.service';
var AppComponent = /** @class */ (function () {
    function AppComponent(router, toastr, loginService, alertService, vRef) {
        this.router = router;
        this.toastr = toastr;
        this.loginService = loginService;
        this.alertService = alertService;
        this.alertNotifyList = [];
        this.showDefaultHeader = true;
        this.isLogin = false;
        this.isBannerClosed = false;
    }
    AppComponent.prototype.ngOnInit = function () {
        var _this = this;
        var bannerClosed = localStorage.getItem('loginBannerClosed');
        if (bannerClosed === 'true') {
            this.isBannerClosed = true;
        }
        this.router.events.subscribe(function (event) {
            if (event instanceof RouteConfigLoadStart) {
                _this.blockUI.start('Loading...');
            }
            else if (event instanceof RouteConfigLoadEnd) {
                _this.blockUI.stop();
            }
        });
        this.router.events.subscribe(function (event) {
            if (event instanceof NavigationEnd) {
                gtag('config', 'UA-152080969-1', {
                    page_path: event.urlAfterRedirects,
                });
                var customHeaderRoutes = ['order-summary'];
                var customHeaderValue = event.urlAfterRedirects.split('/')[1];
                _this.showDefaultHeader = !customHeaderRoutes.includes(customHeaderValue);
            }
        });
        this.subscribeToVerbiage();
    };
    AppComponent.prototype.ngOnDestroy = function () {
        if (this.verbiageSubscription) {
            this.verbiageSubscription.unsubscribe();
        }
    };
    AppComponent.prototype.closeBanner = function () {
        this.isBannerClosed = true;
        localStorage.setItem('loginBannerClosed', 'true');
    };
    AppComponent.prototype.subscribeToVerbiage = function () {
        var _this = this;
        this.verbiageSubscription = this.loginService.verbiage.subscribe(function (verbiage) {
            _this.verbiage = verbiage;
        }, function (error) {
            console.error('Error receiving verbiage:', error);
            _this.toastr.error('Failed to load verbiage. Please try again later.', 'Error');
        });
    };
    AppComponent.prototype.onRouterChange = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            var token_1, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        if (!(window.location.pathname == '/login')) return [3 /*break*/, 1];
                        this.isLogin = true;
                        this.alertNotifyList = [];
                        return [3 /*break*/, 3];
                    case 1:
                        this.isLogin = false;
                        if (!(this.alertNotifyList.length === 0)) return [3 /*break*/, 3];
                        token_1 = this.loginService.getToken();
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                _this.alertService.getAlertsByUser(token_1.customernumber, token_1.userName).subscribe(function (notifications) { return _this.alertNotifyList = notifications; }, function (err) {
                                    console.error(err);
                                    reject();
                                }, function () { return resolve(); });
                            })];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        console.error('Error fetching alerts:', error_1);
                        this.toastr.error('Failed to load alerts. Please try again later.', 'Error');
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    AppComponent.prototype.onHideTalkDeskChat = function () {
        try {
            if (window.location.pathname != '/login') {
                if (webchat != undefined) {
                    if (webchat.selfHostedApp != undefined) {
                        webchat.selfHostedApp.close();
                    }
                }
            }
        }
        catch (e) {
            console.error('Error hiding TalkDesk chat:', e);
        }
    };
    __decorate([
        BlockUI(),
        __metadata("design:type", Object)
    ], AppComponent.prototype, "blockUI", void 0);
    return AppComponent;
}());
export { AppComponent };
